import { render, staticRenderFns } from "./TaggedQuestion.vue?vue&type=template&id=e05da914&"
import script from "./TaggedQuestion.vue?vue&type=script&lang=js&"
export * from "./TaggedQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports